import { valueOfBetween } from '../utils/funtions'
import {
  DEACELERATION_FACTOR,
  MAX_SCROLL_VELOCITY,
  DRAG_FACTOR,
  AXIS_NAVIGATION,
  VIEWPORT_CONFIG,
} from './../constants/game'
import { CURSOR_SCROLLING_HAND } from './../constants/assets'
import Cursor from './cursor'

export default class ViewportComponent {
  /** @type { Phaser.GameObjects.Image } */
  viewportContent

  /**
   * @type {{
   * context: Phaser.Scene,
   * painter: Phaser.GameObjects.Graphics,
   * }}
   **/
  config = {}


  /** @type { Cursor } */
  cursor
  /**
   * @param { Phaser.Scene } context
   *  @param { Cursor } cursor
   */
  constructor(context, cursor) {
    this.config.context = context
    this.cursor = cursor;
  }

  // LOAD assets
  preload() { }


  create() {
    this.config.context.cameras.main.setOrigin(0)
    this.MEDIA_TYPE = this.config.context.data.get('mediaType')
    // # DEFINE CONFIG VIEWPORT
    let VIEWPORT_CONTAINER = {
      ...VIEWPORT_CONFIG,
      width: this.config.context.game.config.width,
      height: this.config.context.game.config.height,
    }

    // // ## DEFINE PAINTER GRAPHICS
    this.config.painter = this.config.context.make.graphics({
      x: 0,
      y: 0,
      add: false,
    })

    // // ## SET PAINTER STYLES
    this.config.painter.fillStyle(0, 0);

    // // ## MAKE TEXTURE FROM DRAW
    const VIEW_PORT_KEY = `${this.config.context.scene.key}-viewport`
    this.config.painter.generateTexture(
      VIEW_PORT_KEY,
      VIEWPORT_CONTAINER.width,
      VIEWPORT_CONTAINER.height
    )

    this.config.painter.destroy() // REMOVE PAINTER

    // ADD border VIEWPORT
    this.viewportContent = this.config.context.physics.add
      .image(0, 0, VIEW_PORT_KEY)
      .setOrigin(0)
      .setCollideWorldBounds(true)
      .setInteractive()
      .setDamping(true)
      .setDebug(false)// ESTO LE DA EL BORDEADO 
      .setDrag(DEACELERATION_FACTOR)

    // VIEW_PORT DRAG EVENTS
    this.viewportContent.on(
      'dragstart',
      function () {
        // pointer, dragX, dragY
        this.viewportContent.setDamping(false)
        // this.config.context.input.setDefaultCursor(
        //   `url(${CURSOR_SCROLLING_HAND}), pointer`
        // )
        this.cursor.grabbing();
      },
      this
    )

    this.viewportContent.on(
      'drag',
      function (_, dragX, dragY) {

        // pointer, dragX, dragY
        const newVelocity = {
          x:
            valueOfBetween(
              (this.viewportContent.x - dragX) * DRAG_FACTOR,
              -MAX_SCROLL_VELOCITY,
              MAX_SCROLL_VELOCITY
            ) * AXIS_NAVIGATION,
          y:
            valueOfBetween(
              (this.viewportContent.y - dragY) * DRAG_FACTOR,
              -MAX_SCROLL_VELOCITY,
              MAX_SCROLL_VELOCITY
            ) * AXIS_NAVIGATION,
        }
        this.viewportContent.setVelocity(newVelocity.x, newVelocity.y)
      },
      this
    )
    this.viewportContent.on(
      'dragend',
      function () // pointer, dragX, dragY
      {

        this.viewportContent.setDamping(true) // ACTIVE DEACELERATION
        //this.config.context.input.setDefaultCursor('')
        this.cursor.default();
      },
      this
    )

    this.config.context.input.setDraggable(this.viewportContent)
    this.config.context.cameras.main.startFollow(this.viewportContent)



    this.cursor.default();
    window.$vp = this;
  }

}
